

interface Props {
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
}
export default function BookInHandSVG({ marginLeft, marginRight, marginTop, marginBottom }: Props) {
  return (
    <svg
      width='102'
      height='121'
      viewBox='0 0 102 121'
      fill='none'
      style={{
        marginLeft,
        marginRight,
        marginTop,
        marginBottom,
      }}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.67601 77.4645C8.67601 101.136 27.8652 120.325 51.5362 120.325C75.2072 120.325 94.3964 101.136 94.3964 77.4645C94.3964 53.7935 75.2072 34.6044 51.5362 34.6044C27.8652 34.6044 8.67601 53.7935 8.67601 77.4645Z'
        fill='#D6E4FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.6158 80.7966C39.8557 80.8403 41.0759 81.2331 42.0443 82.009C43.2665 82.9884 43.9529 84.3445 43.8639 85.5761C43.6932 87.9389 40.6333 90.3298 37.0359 89.4047C26.2866 86.1377 15.537 82.8709 4.78738 79.6039C16.0634 80.0016 27.3398 80.399 38.6158 80.7966Z'
        fill='#081F2D'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.6158 80.7966C39.8557 80.8403 41.0759 81.2331 42.0443 82.009C43.2665 82.9884 43.9529 84.3445 43.8639 85.5761C43.6932 87.9389 40.6333 90.3298 37.0359 89.4047C26.2866 86.1377 15.537 82.8709 4.78738 79.6039C16.0635 80.0016 27.3398 80.399 38.6158 80.7966Z'
        stroke='#081F2D'
        strokeWidth='0.514351'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <mask
        id='mask0_93_1438'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='56'
        width='74'
        height='34'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M47.844 58.6C43.3778 59.7153 41.6087 60.3694 39.8168 60.831H39.8122C38.8714 61.0727 37.9261 61.2655 36.5869 61.4446C32.394 62.0044 28.8777 61.8566 26.5257 61.6328C24.5459 61.4446 22.109 61.458 19.5019 62.4031C14.2922 64.2846 11.3941 68.67 8.31655 73.3199C6.62318 75.8823 4.37908 79.7927 2.59174 85.034L20.3172 89.4507C20.8505 88.1067 21.5356 86.6107 22.4317 85.034C23.1034 83.8469 23.7979 82.7897 24.4699 81.858C26.2168 81.9608 28.3222 82.0149 30.6918 81.9295C34.5755 81.7905 39.8524 81.2666 52.8163 77.4185C52.8163 77.4185 73.6685 71.237 75.1155 66.2332C75.2004 65.9333 75.4515 65.064 75.0349 64.3339C74.6138 63.5813 73.673 63.2049 72.1143 63.0975L72.3156 63.0887C72.5847 62.8199 73.3595 61.9865 73.1579 61.1669C73.0907 60.9024 72.8174 60.2037 70.9494 59.711C69.4445 59.3124 67.7241 59.2048 66.031 59.254L66.219 59.2407C65.9772 58.9807 65.5786 58.5911 65.0273 58.1925C63.7174 57.2424 62.1246 56.6692 59.515 56.6694C56.8955 56.6694 53.2518 57.2469 47.844 58.6Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_93_1438)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M47.844 58.6C43.3778 59.7153 41.6087 60.3694 39.8168 60.831H39.8122C38.8714 61.0727 37.9261 61.2655 36.5869 61.4446C32.394 62.0044 28.8777 61.8566 26.5257 61.6328C24.5459 61.4446 22.109 61.458 19.5019 62.4031C14.2922 64.2846 11.3941 68.67 8.31655 73.3199C6.62318 75.8823 4.37908 79.7927 2.59174 85.034L20.3172 89.4507C20.8505 88.1067 21.5356 86.6107 22.4317 85.034C23.1034 83.8469 23.7979 82.7897 24.4699 81.858C26.2168 81.9608 28.3222 82.0149 30.6918 81.9295C34.5755 81.7905 39.8524 81.2666 52.8163 77.4185C52.8163 77.4185 73.6685 71.237 75.1155 66.2332C75.2004 65.9333 75.4515 65.064 75.0349 64.3339C74.6138 63.5813 73.673 63.2049 72.1143 63.0975L72.3156 63.0887C72.5847 62.8199 73.3595 61.9865 73.1579 61.1669C73.0907 60.9024 72.8174 60.2037 70.9494 59.711C69.4445 59.3124 67.7241 59.2048 66.031 59.254L66.219 59.2407C65.9772 58.9807 65.5786 58.5911 65.0273 58.1925C63.7174 57.2424 62.1246 56.6692 59.515 56.6694C56.8955 56.6694 53.2518 57.2469 47.844 58.6Z'
          fill='url(#paint0_linear_93_1438)'
        />
      </g>
      <path
        d='M50.4527 67.2171C53.7255 65.9173 57.9297 64.5794 62.9274 63.7609C67.1797 63.0644 70.9825 62.9115 74.1295 62.9893'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        d='M46.2107 64.1721C49.5704 62.7761 53.6233 61.3849 58.3038 60.3393C61.6215 59.5981 64.7051 59.1532 67.4719 58.8968'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M36.7933 74.0171C36.1158 74.0171 35.4796 73.6862 35.0908 73.1322L32.4236 69.3177L97.2291 28.4129L100.309 30.436C100.898 30.823 101.247 31.4755 101.243 32.1811C101.238 32.8877 100.88 33.5365 100.284 33.9164L37.9054 73.6925C37.5719 73.905 37.1874 74.0171 36.7933 74.0171Z'
        fill='white'
      />
      <mask
        id='mask1_93_1438'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='32'
        y='28'
        width='70'
        height='47'
      >
        <path fillRule='evenodd' clipRule='evenodd' d='M32.0582 28.1071H101.5V74.2742H32.0582V28.1071Z' fill='white' />
      </mask>
      <g mask='url(#mask1_93_1438)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M97.2316 28.1071L32.0582 69.2443L34.8803 73.2801C35.3331 73.9258 36.0563 74.2742 36.793 74.2742C37.2222 74.2742 37.656 74.1559 38.0433 73.9091L100.422 34.1333C101.847 33.2246 101.862 31.1485 100.45 30.2208L97.2316 28.1071ZM97.2261 28.7188L100.167 30.6509C100.691 30.9952 100.99 31.5522 100.985 32.1795C100.981 32.7985 100.667 33.3669 100.146 33.6996L37.7672 73.4754C37.4749 73.6616 37.1379 73.7599 36.7931 73.7599C36.1994 73.7599 35.6418 73.4701 35.3018 72.9853L32.7889 69.3914L97.2261 28.7188Z'
          fill='#081F2D'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M60.2051 2.19292C61.4839 1.36834 62.9628 0.932556 64.4818 0.932556C66.6744 0.932556 68.7864 1.85364 70.2764 3.45985L72.2991 5.64029L22.549 26.4715L60.2051 2.19292Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M64.4818 0.675293C62.958 0.675293 61.4238 1.10122 60.0656 1.97683L19.9619 27.8336L72.738 5.73544L70.4648 3.28494C68.8733 1.56909 66.6888 0.675293 64.4818 0.675293ZM64.4818 1.18966C66.6031 1.18966 68.6464 2.08093 70.0877 3.63459L71.8601 5.54548L25.1362 25.1093L60.3443 2.40909C61.5817 1.61129 63.0123 1.18966 64.4818 1.18966Z'
        fill='#081F2D'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.0584 69.2435L29.4854 65.5648C28.7086 64.454 29.04 62.9172 30.2056 62.2253L88.0232 27.911C90.0556 26.705 92.5114 26.4397 94.7545 27.1839L96.6196 27.8026C98.4855 28.4218 98.7935 30.9314 97.1325 31.9831L36.7929 70.1932C35.2145 71.1928 33.1291 70.7745 32.0584 69.2435Z'
        fill='#C5E79F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.2057 62.2253L16.8659 39.0201C14.6008 35.0801 15.9933 30.0485 19.9619 27.8335L62.6454 4.00937C65.9971 2.13866 70.198 2.85739 72.7379 5.73533C74.5799 7.82229 76.4963 10.3183 78.297 13.2578C82.2054 19.6385 84.0418 25.6174 84.9596 29.7295L30.2057 62.2253Z'
        fill='#C5E79F'
      />
      <path
        d='M79.7516 32.8204C78.5142 29.2483 76.7193 24.9819 74.0808 20.4209C71.5265 16.005 68.8206 12.4176 66.4118 9.61523'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        d='M76.4914 34.7552C75.254 31.183 73.4591 26.9166 70.8207 22.3557C68.2663 17.9397 65.5604 14.3524 63.1516 11.55'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        d='M73.7727 36.3688C72.5353 32.7967 70.7404 28.5303 68.1019 23.9693C65.5476 19.5534 62.8417 15.966 60.4329 13.1636'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        d='M51.139 49.8016C49.9017 46.2295 48.1067 41.9631 45.4683 37.4019C42.914 32.9862 40.2081 29.3989 37.7992 26.5965'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path d='M37.419 61.2428L39.992 64.9215' stroke='#081F2D' strokeWidth='0.514351' />
      <path
        d='M82.4321 31.2295C83.0829 31.4619 83.9474 31.849 84.8495 32.5043C85.9694 33.3175 86.6972 34.2166 87.1343 34.8542'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path d='M30.2057 62.2253L84.9596 29.7294' stroke='#081F2D' strokeWidth='0.514351' />
      <mask
        id='mask2_93_1438'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='61'
        width='58'
        height='25'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.501 62.4022C14.292 64.2853 11.3941 68.6679 8.3189 73.3183C6.62301 75.8825 4.37815 79.7927 2.5946 85.0327L31.4331 77.8194C33.5716 78.2789 36.6699 78.7821 40.4174 78.8102C46.2902 78.8536 58.5073 77.7648 59.7298 72.6645C59.7899 72.4136 60.0297 71.4145 59.5653 70.3961C57.8975 66.7363 50.3782 69.9255 40.7357 66.7671C35.0495 64.9048 34.4978 62.7587 28.7512 61.9169C27.6369 61.7537 26.2267 61.5367 24.6248 61.5367C23.0666 61.5367 21.327 61.7421 19.501 62.4022Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_93_1438)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.501 62.4022C14.292 64.2853 11.3941 68.6679 8.3189 73.3183C6.62301 75.8825 4.37815 79.7927 2.5946 85.0327L31.4331 77.8194C33.5716 78.2789 36.6699 78.7821 40.4174 78.8102C46.2902 78.8536 58.5073 77.7648 59.7298 72.6645C59.7899 72.4136 60.0297 71.4145 59.5653 70.3961C57.8975 66.7363 50.3782 69.9255 40.7357 66.7671C35.0495 64.9048 34.4978 62.7587 28.7512 61.9169C27.6369 61.7537 26.2267 61.5367 24.6248 61.5367C23.0666 61.5367 21.327 61.7421 19.501 62.4022Z'
          fill='url(#paint1_linear_93_1438)'
        />
      </g>
      <path
        d='M28.7509 61.9169C34.4977 62.7587 35.0492 64.9047 40.7356 66.7671C50.3782 69.9252 57.8972 66.7363 59.565 70.3959C60.0294 71.4145 59.7899 72.4136 59.7297 72.6642C58.507 77.7648 46.2902 78.8536 40.4173 78.8099C36.6696 78.7821 33.5716 78.2786 31.4328 77.8191'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.729617 102.987C0.27817 98.4484 0.30217 92.0671 2.59174 85.0339C3.24251 83.0343 3.99787 81.2237 4.78733 79.6039C21.4406 85.02 33.8449 88.5396 37.0359 89.4046C37.9415 89.6499 39.429 89.8156 40.9175 89.1472C42.3969 88.4828 43.2429 87.2322 43.6787 86.4344C40.5956 96.5477 37.5126 106.661 34.4295 116.774'
        fill='#3B61EB'
      />
      <path
        d='M41.3361 94.1188V94.1188C37.363 95.3656 33.1045 95.3731 29.1268 94.1403C20.1977 91.373 11.2683 88.6055 2.33914 85.8382'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <path
        d='M4.78737 79.6039C15.537 82.8709 26.2863 86.1376 37.0359 89.4046C37.5217 89.5365 39.1213 89.9043 40.9173 89.1472C42.5841 88.4446 43.4188 87.211 43.6944 86.3854C43.6891 86.4016 43.6841 86.418 43.6788 86.4344'
        stroke='#081F2D'
        strokeWidth='0.514351'
      />
      <defs>
        <linearGradient
          id='paint0_linear_93_1438'
          x1='-12.2692'
          y1='89.4507'
          x2='60.4074'
          y2='89.4507'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_93_1438'
          x1='-6.21785'
          y1='85.0327'
          x2='51.0327'
          y2='85.0327'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
      </defs>
    </svg>
  );
}
